import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import Form, { Actions, EmailAddressValidator, Password, PasswordValidator, RequiredValidator, TextField } from '../../Components/Form';
import Section from '../../Components/Containers/Section';
import { useUser } from '../../Data/Users';
import Loading from '../../Components/Loading';
import { useDialogues } from '../../Components/Dialogues';
import { useSession } from '../../Components/Session';
import Alert from '../../Components/Alert';

const Profile = () => {
    const {user, update, changePassword, changeEmail, refresh} = useUser();
    const {refreshSession} = useSession();
    const {info} = useDialogues();

    const handleChangePassword = async (data) => {
        if (data.newPassword !== data.confirmPassword) {
            info({title: 'Passwords do not match', message: 'Please make sure you have entered the same password in both fields.'});
            return;
        }
        await changePassword(data);
    }

    const handleEmailChange = async (data) => {
        await changeEmail(data).then(() => info(
            {title: 'Confirmation required', message: 'Please check your email for a confirmation link.\nContinue to log in with your existing email until you have confirmed your new email address.'}
        ));
    }

    const afterSubmit = () => {
        refresh();
        refreshSession();
    }

    return <>
        <TopBar left="BackBtn" title="Profile" />

        <Page>

            {(user && user.requestedEmail) && <Alert theme="warning"
                title="Email verification required"
                message={`Check your email for a verification link. You must continue to log in with your current email address until your verified your new email address.`}
            />}

            <Section title="Change Name">
                <Form data={user} waitForData={<Loading size="2x" center className="my-5" />} onSubmit={update} afterSubmit={afterSubmit}>
                    <TextField name="firstName" label="First name" validators={[RequiredValidator]} />
                    <TextField name="lastName" label="Last name" validators={[RequiredValidator]} />
                    <Actions submit={{label: 'Change name'}} />
                </Form>
            </Section>

            <Section title="Change Password">
                <Form onSubmit={handleChangePassword} afterSubmit={afterSubmit}>
                    <Password name="currentPassword" label="Current password" validators={[RequiredValidator]} />
                    <Password name="newPassword" label="New password" showPrompts validators={[RequiredValidator, PasswordValidator]} />
                    <Password name="confirmPassword" label="Confirm new password" validators={[RequiredValidator]} />
                    <Actions submit={{label: 'Change password'}} />
                </Form>
            </Section>

            <Section title="Change Email">
                {user && user.requestedEmail && <p className="my-3">
                    <strong>Change pending:</strong><br />
                    {user.requestedEmail}
                </p>}
                <Form data={user} waitForData={<Loading size="2x" center className="my-5" />} onSubmit={handleEmailChange} afterSubmit={afterSubmit}>
                    <TextField type="email" name="email" label="Email" validators={[RequiredValidator, EmailAddressValidator]} />
                    <Actions submit={{label: 'Change email'}} />
                </Form>
            </Section>
        </Page>
    </>
}

export default Profile;
